/* eslint-disable no-alert */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
  IconButton,
  Table,
  FormControlLabel,
  makeStyles,
  Typography,
  ListItem,
  ListItemText,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  Box,
  Menu,
  MenuItem,
} from '@material-ui/core';
import { TableHead } from '@aws-amplify/ui-react';
import PropTypes from 'prop-types';
import {
  React, useEffect, useState, useCallback,
} from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import InfoIcon from '@material-ui/icons/Info';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PauseIcon from '@material-ui/icons/Pause';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import DeleteIcon from '@material-ui/icons/Delete';
import { Doughnut } from 'react-chartjs-2';
import moment from 'moment';
import SummaryIcon from '@material-ui/icons/Assessment';
import { useHistory } from 'react-router-dom'; // Assuming you're using react-router
import { useQuery } from '@tanstack/react-query';
import GraphqlService from '../../service/graphqlService';
import EditableInput from '../EditableInput';
import useGetDevicesNotAllowed from '../../hooks/useGetDevicesNotAllowed';
import {
  formatToPrintableDate,
} from '../../utils/dateUtils';

import {
  DELETE_DEPLOY_PERMISSION,
} from '../../utils/constants';
import Restricted from '../../authorization/Restricted';
import { useSnackbar } from '../../providers/SnackbarContext';
import { useProject } from '../../config/ProjectContext';
import JsonPopup from '../JsonPopup';
import useAnalytics from '../../hooks/useAnalytics';
import useRegionFeatureGate from '../../hooks/useRegionFeatureGate';
import DeploymentType from './DeploymentType';
import StagedDeploymentDetails from './StagedDeploymentDetails';
import UnreachableBadge from './UnreachableBadge';
import UnreachableTooltip from './UnreachableTooltip';
import {
  OVERALL_STATUS_SOURCE, buildOverallStatusFromCounts, buildLifecycleCounts,
} from '../../utils/overallStatusSource';

const useStyles = makeStyles((theme) => ({
  rootDetail: {
    flexGrow: 1,
    background: '#E2E2E2',
    height: '100%',
  },
  statusBullet: {
    display: 'inline-block',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    marginRight: '5px',
  },
  detailItem: {
    borderRadius: '8px 0px 0px 8px',
    background: '#fff',
  },
  detailInfoItem: {
    padding: 10,
  },
  detailInsight: {
    background: '#fff',
    borderRadius: '0px 8px 8px 0px',
    padding: 8,
  },
  infoSection: {
    textAlign: 'left',
    height: '100%',
    background: '#fff',
    borderRadius: 8,
    padding: 12,
  },
  headerDetailTitle: {
    paddingBottom: theme.spacing(2),
    fontWeight: 'bold',
  },
  infoValue: {
    marginBottom: theme.spacing(1),
  },
  headerValue: {
    fontWeight: 'bold',
  },

  details: {
    padding: 0,
  },
  cardTitle: {
    fontSize: 16,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  cardContent: {
    backgroundColor: '#fff',
    color: theme.palette.primary.text,
    flexGrow: 1,
  },
  detailsTitle: {
    fontSize: 14,
    paddingRight: '8px',
  },
  accordionContainer: {
    marginLeft: 24,
    marginRight: 24,
    borderRadius: '0px',
    overflow: 'hidden',
    maxWidth: 'calc(100vw - 48px)',
  },
  root: {
    padding: 0,
    backgroundColor: '#fff',
    marginBottom: 4,
    marginTop: 4,
    borderRadius: '0px',
    overflow: 'hidden',
    maxWidth: '100%',
  },
  summaryRoot: {
    backgroundColor: '#fff',
    borderRadius: '0px',
    margin: 0,
    overflow: 'hidden',
    maxWidth: '100%',
    minHeight: 'auto',
  },
  accordionContent: {
    margin: 0,
    overflow: 'hidden',
    maxWidth: '100%',
    flexWrap: 'nowrap',
  },
  headingTitle: {
    fontSize: 16,
    fontWeight: theme.typography.fontWeightMedium,
  },
  mainDetailTitle: {
    padding: theme.spacing(2),
    fontWeight: 'bold',
  },
  headingTitleElements: {
    fontWeight: theme.typography.h6.fontWeight,
    fontFamily: theme.typography.h5.fontFamily,
    lineHeight: theme.typography.h5.lineHeight,
    letterSpacing: theme.typography.h5.letterSpacing,
    fontSize: theme.typography.h5.fontSize,
    color: theme.palette.primary.text,
  },
  headingDescription: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.secondary.text,
  },
  headingDate: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.primary.text,
  },
  headingDeletedDate: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular,
    color: 'red',
  },
  detailsText: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.secondary.text,
  },
  iconsBox: {
    float: 'center',
    margin: 0,
  },
  icon: {
    color: theme.palette.primary.text,
  },
  block: {
    background: theme.palette.background.default,

  },
  blockTitle: {
    fontSize: 16,
    fontWeight: 500,

  },
  key: {
    color: theme.palette.primary.subMain,
    whiteSpace: 'nowrap',
  },
  cardHeader: {
    padding: 10,
  },
  tableBodyDetailItem: {
    height: '100%',
    background: '#fff',
  },
  tableHeadDetailItem: {
    background: '#F2F2F2',
  },
  tableHead: {
    fontWeight: 'bold',
  },
  bodyValue: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  overallContainer: {
    background: '#E2E2E2',
    padding: 10,
  },
  overallRootContainer: {
    marginBottom: 32,
  },
  infoItems: {
    marginBottom: 6,
  },
  deployHeaderItem: {
    marginBottom: 16,
  },
  tableStatus: {
    margin: 8,
    borderRadius: 8,
  },
  insightContainer: {
    width: '100%',
    height: '100%',
    maxWidth: 350,
    maxHeight: 350,
    alignContent: 'center',
    alignItems: 'center',
  },
  detailSerialFilterStyle: {
    width: '100%',
    minWidth: 250,

  },
  detailStatusFilterStyle: {
    width: '100%',
    minWidth: 190,
    marginTop: 6,
    paddingRight: 12,
  },
  dotsIcons: {
    alignSelf: 'center',
  },
  developmentTypeIcons: {
    alignSelf: 'flex-start',
  },
  downloadCloud: {
    padding: 0,
  },
  globalDeployIcon: {
    marginTop: 4,
  },
  gridChartProgress: {
    marginTop: 16,
    marginLeft: 16,
  },
  jsonCopyButton: {
    backgroundColor: theme.palette.primary.button,
    color: theme.palette.common.white,
    padding: '8px 16px',
    borderRadius: 12,
    '& :disabled': {
      color: theme.palette.primary.light,
    },
  },
  loadingContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 42,
  },
  sourceToggleContainer: {
    border: '1px solid #ccc',
    borderRadius: 16,
    overflow: 'hidden',
    marginRight: 8,
  },
  sourceToggleButton: {
    border: 'none',
    background: 'transparent',
    padding: '4px 10px',
    fontSize: 12,
    cursor: 'pointer',
    color: theme.palette.text.secondary,
  },
  sourceToggleButtonActive: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  sourceToggleButtonDisabled: {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
}));

export default function DeploymentAccordion({
  deployment, id, deleted, deleteDeploy, expandedProp, onDetails, onSummary, onDownload, onExpand, onDeploymentUpdate,
}) {
  const parsedTarget = (() => {
    try {
      const parsed = JSON.parse(deployment.target);
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch (e) {
      // Handle comma-separated string of serial numbers
      if (typeof deployment.target === 'string' && deployment.target.includes(',')) {
        return deployment.target.split(',').map((item) => item.trim()).filter(Boolean);
      }
      return [deployment.target];
    }
  })();

  const { areAllowed: devicesNotAllowed } = useGetDevicesNotAllowed(parsedTarget);

  const history = useHistory();

  const classes = useStyles();

  const [overallStatus, setOverallStatus] = useState([]);
  const [overallStatusSource, setOverallStatusSource] = useState(OVERALL_STATUS_SOURCE.FOTA_LIFECYCLE);

  const { project } = useProject();

  const [expanded, setExpanded] = useState(expandedProp || false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [isPausing, setIsPausing] = useState(false);
  const [commentValue, setCommentValue] = useState(deployment.deployDescription?.userDescription || '');

  const openSnackBar = useSnackbar();

  const { setAnalytics } = useAnalytics();

  const isFeatureAvailable = useRegionFeatureGate();


  const handleNavigate = (url) => {
    if (deployment?.deploymentID && deployment?.dateTime && project?.code) {
      const unixDate = moment(deployment.dateTime).unix();
      const newUrl = history.createHref({ pathname: `${url}/${project.code}/${deployment.deploymentID}/${unixDate}` });
      window.open(newUrl, '_blank'); // Opens in a new tab
    }
  };

  const handleViewDeployment = () => {
    if (deployment?.deploymentID && project?.code) {
      history.push(`/deployments/${project.code}/${deployment.deploymentID}`);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      openSnackBar('Value copied successfully to the clipboad!', 'success');
    }).catch((err) => {
      openSnackBar('Failed to copy text to clipboard', err);
    });
  };

  const openAsset = (fileId) => {
    const url = `${window.location.origin}/#/assetDetail/${fileId}`;
    window.open(url, '_blank');
  };

  const handleMenuClick = (event) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  

  const handlePauseToggle = async () => {
    setIsPausing(true);
    try {
      // Prevent resuming if deployment is paused and stage target has been reached (Stage Status)
      if (deployment.deployPaused && stageComplete) {
        openSnackBar('Cannot resume: target already reached for current stage', 'warning');
        return;
      }
      const isPaused = deployment.deployPaused || false;
      const requestBody = {
        DeployPaused: !isPaused
      };

      await GraphqlService.updateDeployment(
        project.code,
        deployment.deploymentID,
        requestBody
      );

      openSnackBar(
        `Deployment ${!isPaused ? 'paused' : 'resumed'} successfully`,
        'success'
      );
      
      // Optionally trigger a refetch of deployments here
      window.location.reload(); // Simple approach, could be improved with proper state management
    } catch (error) {
      openSnackBar(`Error ${deployment.deployPaused ? 'resuming' : 'pausing'} deployment: ${error.message}`, 'error');
    } finally {
      setIsPausing(false);
      handleMenuClose();
    }
  };

  const handleDelete = () => {
    setAnalytics({
      event: 'button_clicked',
      extraParams: { name: 'asset_management-deployments-delete' }
    });
    deleteDeploy(deployment.deploymentID);
    handleMenuClose();
  };

  const handleCommentChange = async (newValue) => {
    try {
      await GraphqlService.updateDeployment(
        project.code,
        deployment.deploymentID,
        {
          DeployDescription: {
            UserDescription: newValue,
            UserName: deployment.deployDescription?.userName || deployment.actor,
          },
        },
      );
      setCommentValue(newValue);
      openSnackBar('Comment updated successfully', 'success');
    } catch (error) {
      openSnackBar(`Error updating comment: ${error.message}`, 'error');
    }
  };

  const statusColors = {
    Done: 'green',
    Error: 'red',
    Executing: 'orange',
  };

  async function searchDeploymentDetails({
    startDate, deploymentId, params,
  }) {
    const response = await GraphqlService.getLifeCycleObject(
      project.code, `machinecount/${project.code}/${deploymentId}`, JSON.stringify(params), '', startDate, undefined, undefined,
    );

    if (response) {
      const generalData = JSON.parse(response.data);
      return generalData;
    }
    return [];
  }

  // // Define a query function
  const fetchDeploymentDetails = async (params) => {
    if (!expanded) return null;

    return searchDeploymentDetails({
      startDate: moment(deployment.dateTime),
      deploymentId: deployment.deploymentID,
      params,
    });
  };

  const {
    data: dataDeployments,
    isFetching: isFetchingDataDeployments,
  } = useQuery({
    queryKey: ['searchDataDeployments', deployment.deploymentID, expanded],
    queryFn: () => fetchDeploymentDetails({ isError: false }),
    enabled: expanded,
    refetchOnWindowFocus: false,
    staleTime: 30000,
    select: (res) => {
      if (!res?.validData) return [];
      return res.validData.map((item) => ({
        machineCount: item.machineCount,
        status: item.status,
      }));
    },
  });

  const {
    data: dataErrorDeployments,
    isFetching: isFetchingDataErrorDeployments,
  } = useQuery({
    queryKey: ['searchErrorDeployment', deployment.deploymentID, expanded],
    queryFn: () => fetchDeploymentDetails({ isError: true }),
    enabled: expanded,
    refetchOnWindowFocus: false,
    staleTime: 30000,
    select: (res) => {
      if (!res?.validData) return [];
      return res.validData.map((item) => ({
        machineCount: item.machineCount,
        status: item.status,
      }));
    },
  });

  // Fetch machine count KPIs
  const {
    data: machineCountKpis,
    isFetching: isFetchingMachineCountKpis,
  } = useQuery({
    queryKey: ['machineCountKpis', deployment.deploymentID, expanded, project?.code],
    queryFn: async () => {
      const result = await GraphqlService.getMachineCountKpis({
        projectId: project.code,
        deployId: deployment.deploymentID,
        sync: 'true',
      });
      return result;
    },
    enabled: expanded && !!project?.code && !!deployment.deploymentID && isFeatureAvailable('machineKpis'),
    refetchOnWindowFocus: false,
    staleTime: 30000,
  });

  // Fetch machine list KPIs
  const {
    data: machineListKpis,
    isFetching: isFetchingMachineListKpis,
  } = useQuery({
    queryKey: ['machineListKpis', deployment.deploymentID, expanded, project?.code],
    queryFn: async () => {
      const result = await GraphqlService.getMachineListKpis({
        projectId: project.code,
        deployId: deployment.deploymentID,
        sync: 'true',
        page_size: 10,
        page: 0,
      });
      return result;
    },
    enabled: expanded && !!project?.code && !!deployment.deploymentID && isFeatureAvailable('machineKpis'),
    refetchOnWindowFocus: false,
    staleTime: 30000,
  });


  // Determine if staged deployment has reached its current stage target based on Stage Status
  const stageComplete = !!deployment?.canaryMetadata
    && typeof deployment.canaryMetadata.alreadySentTo === 'number'
    && typeof deployment.canaryMetadata.affectedSubset === 'number'
    && deployment.canaryMetadata.alreadySentTo >= deployment.canaryMetadata.affectedSubset;


  const memoizedHandleDetailsClick = useCallback(() => {
    const handleDetailsClick = () => {
      setAnalytics({
        event: 'button_clicked',
        extraParams: { name: 'asset_management-deployments-expand' }
      });
    };
    handleDetailsClick();
  }, [setAnalytics]);

  useEffect(() => {
    if (expanded) {
      memoizedHandleDetailsClick();
    }
  }, [memoizedHandleDetailsClick, expanded]);

  // Preserves today's defaults: Deployment view is KPI-only by default, unless
  // the KPI feature is unavailable for this project (User Story 2), in which
  // case FOTA Lifecycle is the effective default.
  const effectiveOverallStatusSource = overallStatusSource
    || (isFeatureAvailable('machineKpis') ? OVERALL_STATUS_SOURCE.KPI : OVERALL_STATUS_SOURCE.FOTA_LIFECYCLE);

  // this use effect computes the Overall Status chart/table from the selected data source
  useEffect(() => {
    if (effectiveOverallStatusSource === OVERALL_STATUS_SOURCE.FOTA_LIFECYCLE) {
      const counts = buildLifecycleCounts({ successData: dataDeployments, errorData: dataErrorDeployments });
      setOverallStatus(buildOverallStatusFromCounts(counts));
      return;
    }

    // Done now reflects the 'installed' count from the KPI endpoint
    const done = machineCountKpis?.validData?.installed || 0;
    // In progress now reflects the 'inProgress' count from the KPI endpoint
    const executing = machineCountKpis?.validData?.inProgress || 0;
    // Error now reflects the 'error' count from the KPI endpoint
    const error = machineCountKpis?.validData?.error || 0;

    setOverallStatus(buildOverallStatusFromCounts({ done, executing, error }));
  }, [dataDeployments, dataErrorDeployments, machineCountKpis, effectiveOverallStatusSource]);

  const doughnutOptions = {
    plugins: {
      tooltip: {
        enabled: false,
      },
    },
    cutout: '70%',
    responsive: true,
  };

  const hasInsight = JSON.stringify(overallStatus?.chartData?.datasets[0]?.data) !== JSON.stringify([0, 0, 0]);

  // Gate loading per selected source so an in-flight fetch for the just-selected
  // source shows loading instead of a stale/zero chart.
  const isLoading = effectiveOverallStatusSource === OVERALL_STATUS_SOURCE.FOTA_LIFECYCLE
    ? (isFetchingDataDeployments || isFetchingDataErrorDeployments)
    : (isFetchingMachineCountKpis || isFetchingMachineListKpis);

  if (!deployment || !deployment.file || !statusColors) {
    return null;
  }

  return (
    <div className={classes.accordionContainer}>
      <Accordion className={classes.root} id={`deployment-accordion-detail-${id}`} expanded={expanded} TransitionProps={{ unmountOnExit: true }} onChange={
        () => setExpanded(!expanded)
      }>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon id={`${id}btnExpand`} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.summaryRoot}
          classes={{ content: classes.accordionContent }}
        >
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            display="flex-start"
          >
            <Grid item xs={2} sm={2} className={classes.dotsIcons}>
              <Grid container display="flex" direction="row" justifyContent="center">
                <Tooltip title="View Full Deployment Detail" arrow>
                  <IconButton
                    onClick={(event) => {
                      event.stopPropagation();
                      setAnalytics({
                        event: 'button_clicked',
                        extraParams: { name: 'asset_management-deployments-view_detail' }
                      });
                      handleViewDeployment();
                    }}
                  >
                    <OpenInNewIcon />
                  </IconButton>
                </Tooltip>

                <Tooltip title="View Deployment Details" arrow>
                  <IconButton
                    onClick={(event) => {
                      event.stopPropagation();
                      setAnalytics({
                        event: 'button_clicked',
                        extraParams: { name: 'asset_management-deployments-details' }
                      });
                      handleNavigate('/statistics/deploymentDetails');
                    }}
                  >
                    <InfoIcon />
                  </IconButton>
                </Tooltip>

                <Tooltip title="View Deployment Summary" arrow>
                  <IconButton
                    onClick={(event) => {
                      event.stopPropagation();
                      setAnalytics({
                        event: 'button_clicked',
                        extraParams: { name: 'asset_management-deployments-summary' }
                      });
                      handleNavigate('/statistics/deploymentStatus');
                    }}
                  >
                    <SummaryIcon />
                  </IconButton>
                </Tooltip>
              </Grid>

            </Grid>

            {/* Type */}
            <Grid item xs={2} sm={1}>
              <ListItem>
                <ListItemText
                  id={`${id}Type`}
                  primary={
                    <Typography variant="caption" color="textSecondary">Type</Typography>
                  }
                  secondary={<Typography variant="body2" component="div">{deployment.file.type}</Typography>}
                />
              </ListItem>
            </Grid>

            {/* Version */}
            <Grid container xs={4} sm={1}>
              <ListItem>
                <ListItemText
                  id={`${id}Version`}
                  primary={
                    <Typography variant="caption" color="textSecondary">Version</Typography>
                  }
                  secondary={<Typography component="div" variant="body2">{deployment.file.assetDescription ? `v.${JSON.parse(deployment.file.assetDescription)?.Version}` : 'Not available'}</Typography>}
                />
              </ListItem>
            </Grid>

            {/* dateTime */}
            <Grid item xs={4} sm={1}>
              <ListItem>
                <ListItemText
                  id={`${id}Date`}
                  primary={
                    <Typography variant="caption" color="textSecondary">Date</Typography>
                  }
                  secondary={<Typography variant="body2">{formatToPrintableDate(deployment.dateTime)}</Typography>}
                />
              </ListItem>
            </Grid>

            {/* DeletedDate */}
            {deleted && (
              <Grid item xs={4} sm={1}>

                <ListItem>
                  <ListItemText
                    id={`${id}DeletedDate`}
                    primary={
                      <Typography variant="caption" color="textSecondary">Deleted Date</Typography>
                    }
                    secondary={<Typography variant="body2" component="div" className={classes.headingDeletedDate}>{formatToPrintableDate(deployment.deleteTime)}</Typography>}
                  />
                </ListItem>

              </Grid>
            )}

            {/* Staged */}
            <Grid item xs={4} sm={1}>
              <ListItem>
                <ListItemText
                  id={`${id}Staged`}
                  primary={
                    <Typography variant="caption" color="textSecondary">Staged</Typography>
                  }
                  secondary={
                    <Typography variant="body2" component="div" style={{ display: 'flex', alignItems: 'center' }}>
                      <span
                        className={classes.statusBullet}
                        style={{ backgroundColor: deployment.canaryMetadata ? '#4caf50' : '#9e9e9e' }}
                      />
                      {deployment.canaryMetadata ? 'Yes' : 'No'}
                    </Typography>
                  }
                />
              </ListItem>
            </Grid>

            {/* Status */}
            <Grid item xs={4} sm={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <ListItem style={{ justifyContent: 'center', padding: '8px 0' }}>
                <ListItemText
                  id={`${id}Status`}
                  primary={
                    <Typography variant="caption" color="textSecondary" style={{ textAlign: 'center' }}>Status</Typography>
                  }
                  secondary={
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '4px' }}>
                      {(() => {
                        let status = 'ONGOING';
                        let backgroundColor = '#4caf50'; // Green for ongoing
                        
                        // Check deployReachable field - if false, show UNREACHABLE badge with tooltip
                        if (deployment.deployReachable === false) {
                          return (
                            <>
                              <UnreachableBadge id={`${id}UnreachableBadge`} />
                              <UnreachableTooltip id={`${id}UnreachableTooltip`} />
                            </>
                          );
                        }
                        
                        // Check deployPaused field directly
                        if (deployment.deployPaused === true) {
                          status = 'PAUSED';
                          backgroundColor = '#2196f3'; // Blue for paused
                        } else {
                          status = 'ONGOING';
                          backgroundColor = '#4caf50'; // Green for ongoing
                        }
                        
                        return (
                          <div style={{
                            backgroundColor: backgroundColor,
                            color: 'white',
                            padding: '4px 12px',
                            borderRadius: '12px',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            display: 'inline-block',
                            minWidth: '70px'
                          }}>
                            {status}
                          </div>
                        );
                      })()}
                    </div>
                  }
                />
              </ListItem>
            </Grid>

            {/* Development Types */}
            <Grid item xs={8} sm={2} className={classes.developmentTypeIcons}>

              <ListItem>
                <ListItemText
                  id={`${id}Development Type`}
                  primary={
                    <Typography variant="caption" color="textSecondary">Deployment Type</Typography>
                  }
                  secondary={(
                    <DeploymentType
                      id={`deployment-${id}`}
                      deployment={deployment}
                    />
                  )}
                />
              </ListItem>

            </Grid>

            {/* Actions Menu */}
            <Grid item xs={1} sm={1} className={classes.dotsIcons}>
              <Grid container display="flex" direction="row" justifyContent="center">

                {!deleted && devicesNotAllowed !== undefined && (
                  <Restricted to={[DELETE_DEPLOY_PERMISSION]}>
                    <Grid container xs={2} sm={1} alignItems="center">

                      {devicesNotAllowed?.length > 0 ? (
                        <Tooltip title={`Devices not allowed: ${devicesNotAllowed.join(', ')}`} arrow>
                          <InfoIcon />
                        </Tooltip>
                      ) : (
                        <>
                          {/* Show direct delete button for non-staged deployments */}
                          {!deployment.canaryMetadata ? (
                            <Tooltip title="Delete Deployment" arrow>
                              <IconButton
                                size="small"
                                aria-label="delete-deployment"
                                id={`DeleteButton-${id}`}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  handleDelete();
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            /* Show menu for staged deployments */
                            <FormControlLabel
                              aria-label="Actions menu"
                              onClick={(event) => event.stopPropagation()}
                              onFocus={(event) => event.stopPropagation()}
                              className={classes.iconsBox}
                              control={(
                                <Tooltip title="Actions" arrow>
                                  <IconButton
                                    size="small"
                                    aria-label="actions-menu"
                                    id={`ActionsMenu-${id}`}
                                    onClick={handleMenuClick}
                                    disabled={isPausing}
                                  >
                                    <MoreVertIcon />
                                  </IconButton>
                                </Tooltip>
                              )}
                            />
                          )}
                        </>
                      )}
                    </Grid>
                  </Restricted>
                )}

                {/* Menu only for staged deployments */}
                {deployment.canaryMetadata && (
                  <Menu
                    anchorEl={menuAnchorEl}
                    open={Boolean(menuAnchorEl)}
                    onClose={handleMenuClose}
                    onClick={(event) => event.stopPropagation()}
                  >
                    <MenuItem onClick={handlePauseToggle} disabled={
                      isPausing || (deployment.deployPaused && stageComplete)
                    }>
                      {deployment.deployPaused ? (
                        <>
                          <PlayArrowIcon style={{ marginRight: 8 }} />
                          Resume
                        </>
                      ) : (
                        <>
                          <PauseIcon style={{ marginRight: 8 }} />
                          Pause
                        </>
                      )}
                    </MenuItem>
                    <MenuItem onClick={handleDelete}>
                      <DeleteIcon style={{ marginRight: 8 }} />
                      Delete
                    </MenuItem>
                  </Menu>
                )}

              </Grid>

            </Grid>

          </Grid>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>

          <Grid container className={classes.rootDetail}>
            <Grid container className={classes.overallRootContainer}>
              <Grid container alignContent="center" xs={12} sm={12} lg={8} className={classes.overallContainer}>
                {isLoading || !overallStatus?.chartData || !overallStatus?.statusInfo ? (
                  <Grid container alignContent="center" justifyContent="center">
                    <Grid>
                      <Typography>
                        LOADING DATA
                      </Typography>
                    </Grid>
                    <Grid className={classes.gridChartProgress}>
                      <CircularProgress size={60} />
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container>
                    {/* Table status */}
                    <Grid
                      container
                      xs={12}
                      sm={12}
                      lg={hasInsight ? 8 : 12}
                      className={classes.detailItem}
                    >
                      <Box display="flex" justifyContent="space-between" width="100%">
                        <Typography variant="subtitle1" className={classes.mainDetailTitle}>
                          Overall Deployment Status
                        </Typography>
                        <Box display="flex" alignItems="center" className={classes.sourceToggleContainer}>
                          <button
                            type="button"
                            className={`${classes.sourceToggleButton} ${effectiveOverallStatusSource === OVERALL_STATUS_SOURCE.FOTA_LIFECYCLE ? classes.sourceToggleButtonActive : ''}`}
                            onClick={(event) => {
                              event.stopPropagation(); // Prevents accordion from expanding
                              setOverallStatusSource(OVERALL_STATUS_SOURCE.FOTA_LIFECYCLE);
                              setAnalytics({
                                event: 'button_clicked',
                                extraParams: { name: 'asset_management-deployments-overall_status_source_toggle' },
                              });
                            }}
                          >
                            FOTA Lifecycle
                          </button>
                          <button
                            type="button"
                            disabled={!isFeatureAvailable('machineKpis')}
                            className={`${classes.sourceToggleButton} ${effectiveOverallStatusSource === OVERALL_STATUS_SOURCE.KPI ? classes.sourceToggleButtonActive : ''} ${!isFeatureAvailable('machineKpis') ? classes.sourceToggleButtonDisabled : ''}`}
                            onClick={(event) => {
                              event.stopPropagation(); // Prevents accordion from expanding
                              if (!isFeatureAvailable('machineKpis')) return;
                              setOverallStatusSource(OVERALL_STATUS_SOURCE.KPI);
                              setAnalytics({
                                event: 'button_clicked',
                                extraParams: { name: 'asset_management-deployments-overall_status_source_toggle' },
                              });
                            }}
                          >
                            KPI
                          </button>
                        </Box>
                      </Box>
                      <Grid container xs={12} sm={12}>
                        <TableContainer style={{ width: '100%', overflowX: 'auto', padding: '8px' }}>
                          <Table aria-label="simple table">
                            <TableHead>
                              <TableRow>
                                <TableCell>Status</TableCell>
                                <TableCell align="right">Devices</TableCell>
                                <TableCell align="right">Percentage</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {/* Done */}
                              <TableRow key={overallStatus?.statusInfo[0].status} className={classes.tableRow}>
                                <TableCell component="th" scope="row">
                                  {overallStatus?.statusInfo[0].status}
                                  {' '}
                                  <span
                                    className={classes.statusBullet}
                                    style={{ backgroundColor: statusColors.Done }}
                                  />
                                </TableCell>
                                <TableCell align="right">{overallStatus?.statusInfo[0].count}</TableCell>
                                <TableCell align="right">{overallStatus?.statusInfo[0].percentage !== undefined ? `${overallStatus?.statusInfo[0].percentage}%` : ''}</TableCell>
                              </TableRow>
                              {/* Error */}
                              <TableRow key={overallStatus?.statusInfo[1].status} className={classes.tableRow}>
                                <TableCell component="th" scope="row">
                                  {overallStatus?.statusInfo[1].status}
                                  {' '}
                                  <span
                                    className={classes.statusBullet}
                                    style={{ backgroundColor: statusColors.Error }}
                                  />
                                </TableCell>
                                <TableCell align="right">{overallStatus?.statusInfo[1].count}</TableCell>
                                <TableCell align="right">{overallStatus?.statusInfo[1].percentage !== undefined ? `${overallStatus?.statusInfo[1].percentage}%` : ''}</TableCell>
                              </TableRow>
                              {/* Executing */}
                              <TableRow key={overallStatus?.statusInfo[2].status} className={classes.tableRow}>
                                <TableCell component="th" scope="row">
                                  In progress
                                  {' '}
                                  <span
                                    className={classes.statusBullet}
                                    style={{ backgroundColor: statusColors.Executing }}
                                  />
                                </TableCell>
                                <TableCell align="right">{overallStatus?.statusInfo[2].count}</TableCell>
                                <TableCell align="right">{overallStatus?.statusInfo[2].percentage !== undefined ? `${overallStatus?.statusInfo[2].percentage}%` : ''}</TableCell>
                              </TableRow>
                              {/* Total */}
                              <TableRow key={overallStatus?.statusInfo[3].status} className={classes.tableRow}>
                                <TableCell component="th" scope="row">
                                  Total
                                  {' '}
                                </TableCell>
                                <TableCell align="right">{overallStatus?.statusInfo[3].count}</TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    </Grid>
                    {/* insight */}
                    {hasInsight && (
                      <Grid container xs={12} sm={12} lg={4} justifyContent="center" className={classes.detailInsight} alignContent="center" alignItems="center">
                        <div className={classes.insightContainer}>
                          {overallStatus?.chartData && <Doughnut data={overallStatus?.chartData} options={doughnutOptions} />}
                        </div>
                      </Grid>
                    )}
                  </Grid>
                )}
              </Grid>
              {/* Detail Grid */}
              <Grid item xs={12} sm={12} lg={4} className={classes.detailInfoItem}>
                <Grid className={classes.infoSection}>
                  <Typography variant="subtitle1" className={classes.headerDetailTitle}>
                    Information
                  </Typography>
                  <Grid container display="flex" direction="row" flex="1" className={classes.infoItems}>
                    <Grid container display="flex" direction="column" flex="1" xs={11}>
                      <Typography variant="body2" className={classes.headerValue}>
                        Deploy ID
                      </Typography>
                      <Typography variant="body2" className={classes.bodyValue}>
                        {deployment.deploymentID}
                      </Typography>
                    </Grid>
                    <Grid container xs={1}>
                      <IconButton onClick={() => copyToClipboard(deployment.deploymentID)}>
                        <FileCopyIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                  <Grid container display="flex" direction="row" className={classes.infoItems}>
                    <Grid item display="flex" flex="1">
                      <Typography variant="body2" className={classes.headerValue}>
                        Actor
                      </Typography>
                      <Typography variant="body2" className={classes.bodyValue}>
                        {deployment.deployDescription?.userName || deployment.actor}
                      </Typography>
                    </Grid>
                    <IconButton onClick={() => copyToClipboard(deployment.deployDescription?.userName || deployment.actor)}>
                      <FileCopyIcon />
                    </IconButton>
                  </Grid>
                  <div className={classes.infoItems}>
                    <Typography variant="body2" className={classes.headerValue}>
                      Comments
                    </Typography>
                    <EditableInput
                      value={commentValue}
                      onChange={handleCommentChange}
                    />
                  </div>
                  {deployment.targetRegex && (
                    <div className={classes.infoItems}>
                      <Typography variant="body2" className={classes.headerValue}>
                        Target Regex
                      </Typography>
                      <Typography variant="body2" className={classes.infoValue}>
                        {deployment.targetRegex}
                      </Typography>
                    </div>
                  )}
                  {deployment.targetMarket && (
                    <div className={classes.infoItems}>
                      <Typography variant="body2" className={classes.headerValue}>
                        Target Market
                      </Typography>
                      <Typography variant="body2" className={classes.infoValue}>
                        {deployment.targetMarket}
                      </Typography>
                    </div>
                  )}
                  {deployment.excludeMarket && (
                    <div className={classes.infoItems}>
                      <Typography variant="body2" className={classes.headerValue}>
                        Exclude Market
                      </Typography>
                      <Typography variant="body2" className={classes.infoValue}>
                        {deployment.excludeMarket}
                      </Typography>
                    </div>
                  )}
                  {deployment.exclude && (
                    <div className={classes.infoItems}>
                      <Typography variant="body2" className={classes.headerValue}>
                        Exclude
                      </Typography>
                      <Typography variant="body2" className={classes.infoValue}>
                        {deployment.exclude}
                      </Typography>
                    </div>
                  )}
                  {deployment.file.fileID && (
                    <Grid container display="flex" direction="row" className={classes.infoItems}>
                      <Grid>
                        <Typography variant="body2" className={classes.headerValue}>
                          Asset
                        </Typography>
                        <Typography variant="body2" className={classes.bodyValue}>
                          Open the associated asset
                        </Typography>
                      </Grid>
                      <IconButton aria-label="openAsset" onClick={() => openAsset(deployment.file.fileID)}>
                        <OpenInNewIcon />
                      </IconButton>
                    </Grid>
                  )}
                  <Box display="flex" justifyContent="flex-end">
                    <JsonPopup
                      title="Deployment JSON"
                      jsonObject={typeof deployment === 'object' && deployment !== null ? deployment : {}}
                    />
                  </Box>
                </Grid>
              </Grid>
              
              {/* Stage Details */}
              {deployment.canaryMetadata && (
                <Grid item xs={12}>
                  <StagedDeploymentDetails 
                    deployment={deployment}
                    onUpdate={() => {
                      // Trigger refetch of deployment data
                      onDeploymentUpdate?.();
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>

        </AccordionDetails>
      </Accordion>
    </div>

  );
}
DeploymentAccordion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  deployment: PropTypes.any,
  id: PropTypes.string,
  deleted: PropTypes.bool,
  deleteDeploy: PropTypes.func,
  expandedProp: PropTypes.bool,
  onDeploymentUpdate: PropTypes.func,
};
DeploymentAccordion.defaultProps = {
  deployment: undefined,
  id: undefined,
  deleted: false,
  deleteDeploy: undefined,
  expandedProp: false,
  onDeploymentUpdate: undefined,
};
